import React from 'react';
import PropTypes from 'prop-types';
import { TableBody } from '@mui/material';
import FinancialProductWarrantiesTableRow from './FinancialProductWarrantiesTableRow';

const FinancialProductWarrantiesTableBody = ({ canWrite, warranties, onEdit, onDelete }) => {
  return (
    <TableBody>
      {warranties?.map(warranty => {
        return <FinancialProductWarrantiesTableRow 
                canWrite={canWrite} 
                key={warranty.leasingFinancialProductXWarrantyId} 
                warranty={warranty} 
                onEdit={onEdit} 
                onDelete={onDelete} 
                />;
      })}
    </TableBody>
  );
};

FinancialProductWarrantiesTableBody.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  warranties: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default FinancialProductWarrantiesTableBody;
